import React from 'react'
import GA4Handler from '../GA4Handler'

// @todo-ga4 Localize? --hrivera
const ga4ReactClickHandler = (e: React.MouseEvent<HTMLElement>) => {
  GA4Handler.clickHandleEvent(e.nativeEvent, {}, e.currentTarget)
}

export default ga4ReactClickHandler
